import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTestEnv } from '../lib/testEnv';

const NAV_ITEMS = [
  { label: 'Bosh sahifa', path: '/admin', icon: '🏠', exact: true },
  { label: 'Foydalanuvchilar', path: '/admin/users', icon: '👥' },
  { label: 'Ustalar moderatsiyasi', path: '/admin/moderation', icon: '🛡️' },
  { label: 'Xizmat kategoriyalari', path: '/admin/service-categories', icon: '🗂️' },
  { label: "Xizmat ko'rsatuvchilar", path: '/admin/providers', icon: '🧰' },
  { label: 'Buyurtmalar', path: '/admin/orders', icon: '📦' },
  { label: 'Disputlar', path: '/admin/disputes', icon: '⚖️' },
  { label: 'Push xabarlar', path: '/admin/notifications', icon: '🔔' },
  { label: 'Kredit hisoblari', path: '/admin/credits', icon: '💳' },
  { label: 'Narx sozlamalari', path: '/admin/commission', icon: '💰' },
  { label: 'Moliyaviy hisobot', path: '/admin/reports', icon: '📊' },
  // Faqat test serverda (prod'da yashirin) — ma'lumotni o'chiradi.
  { label: 'Test tozalash', path: '/admin/test-cleanup', icon: '🧹', testOnly: true },
];

function isActive(item, pathname) {
  if (item.exact) return pathname === item.path;
  return pathname === item.path || pathname.startsWith(item.path + '/');
}

export default function AdminLayout({ children }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const fullName = auth?.user
    ? [auth.user.firstName, auth.user.lastName].filter(Boolean).join(' ') || 'Admin'
    : 'Admin';

  return (
    <div style={s.shell}>
      <aside style={s.sidebar}>
        <div style={s.brand}>
          <img src="/brand-mark.png" alt="" style={s.brandLogo} />
          <span style={s.brandName}>Tezhal Admin</span>
        </div>
        <nav style={s.nav}>
          {NAV_ITEMS.filter((item) => !item.testOnly || isTestEnv()).map((item) => {
            const active = isActive(item, location.pathname);
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                style={{ ...s.navBtn, ...(active ? s.navBtnActive : {}) }}
              >
                <span style={s.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      <div style={s.contentCol}>
        <header style={s.topbar}>
          <div style={s.topbarSpacer} />
          <div style={s.userBox}>
            <span style={s.userName}>{fullName}</span>
            <button onClick={handleLogout} style={s.logoutBtn}>Chiqish</button>
          </div>
        </header>
        <main style={s.main}>{children}</main>
      </div>
    </div>
  );
}

const s = {
  shell: {
    minHeight: '100vh',
    display: 'flex',
    background: 'var(--surface-alt)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  sidebar: {
    width: '240px',
    flexShrink: 0,
    background: 'var(--sidebar)',
    color: 'var(--on-accent)',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '20px 20px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  },
  brandLogo: {
    // Rasm uchun eski gradient kvadrat stillari (fon, radius, markazlash) shart emas.
    width: '30px',
    height: 'auto',
    display: 'block',
  },
  brandName: { fontSize: '16px', fontWeight: '700', letterSpacing: '0.3px' },
  nav: { display: 'flex', flexDirection: 'column', padding: '12px 10px', gap: '2px' },
  navBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '11px',
    padding: '10px 12px',
    background: 'transparent',
    color: '#cbd2e0',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
    textAlign: 'left',
    width: '100%',
  },
  navBtnActive: { background: 'rgba(233,69,96,0.16)', color: 'var(--on-accent)' },
  navIcon: { fontSize: '16px', width: '18px', textAlign: 'center' },
  contentCol: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' },
  topbar: {
    height: '58px',
    background: 'var(--surface)',
    borderBottom: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  topbarSpacer: { flex: 1 },
  userBox: { display: 'flex', alignItems: 'center', gap: '14px' },
  userName: { fontSize: '14px', color: 'var(--text-secondary)', fontWeight: '500' },
  logoutBtn: {
    padding: '7px 16px',
    background: 'var(--brand)',
    color: 'var(--on-accent)',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
  },
  main: { padding: '28px 28px', maxWidth: '1180px', width: '100%', margin: '0 auto', boxSizing: 'border-box' },
};
